import "../../RolloverBike/planpagelayout.css";
import "./newVehicle.css";
import { NewPlanBike } from "./NewPlanBike";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { PayHeader } from "../../Paymentheader/PayHeader";
import { EditOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd/lib";
import NewBikeedit from "./NewBikeEdit";
import ManYearupdate from "./ManufUpdate";
import CustomerType from "./CustomerType";

function NewPlanLayoutBike() {
  // const QuickQuotes = useSelector((state) => state?.vehicledetail?.quickquotes);
  const QuickQuotePost = useSelector(
    (state) => state?.vehicledetail?.quickQuotePost
  );
  // const QuoteInput = useSelector((state) => state?.vehicledetail?.quoteInput);
  const bikeMakedata = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOwner, setisModalOwner] = useState(false);
  const [isModalExp, setisModalExp] = useState(false);
  const [isModalReg, setisModalReg] = useState(false);
  const [isModalBike, setisModalBike] = useState(false);
  // const [product, setproduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [fuelType, setFuelType] = useState("");
  const temp = useSelector((state) => state.addressdetail.data);
  const [Gstload, setGstload] = useState(true);

  useEffect(() => {
    getData();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const inputString = bikeMakedata?.customized_variant;
    const match = inputString?.match(/\(([^)]+)\)$/);
    if (match) {
      const result = match[1];
      // console.log(result);
      if (result === "P") {
        setFuelType("PETROL");
      } else if (result === "D") {
        setFuelType("DIESEL");
      } else if (result === "E") {
        setFuelType("ELECTRIC");
      } else if (result === "BATTERY") {
        setFuelType("BATTERY");
      }
    } else {
      console.log("No match found.");
    }
  }, [bikeMakedata]);

  const handleScroll = () => {
    if (window.scrollY > 80) {
      setScrolled(true);
      // console.log(scrolled);
    } else {
      setScrolled(false);
      // console.log(scrolled);
    }
  };
  const getData = async () => {
    if (temp) {
      setLoading(true);
    }
  };

  const policyTypeClick = () => {
    setIsModalOpen(true);
  };
  const ownerType = () => {
    setisModalOwner(true);
  };
  const HandleExp = () => {
    setisModalExp(true);
  };
  const HandleManuf = () => {
    setisModalReg(true);
  };
  const HandleBike = () => {
    setisModalBike(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleCancelOwn = () => {
    setisModalOwner(false);
  };
  const handleCancelExp = () => {
    setisModalExp(false);
  };
  const handleCancelReg = () => {
    setisModalReg(false);
  };
  const handleCancelBike = () => {
    setisModalBike(false);
  };
  // const onGstChange = (checked) => {
  //   console.log(checked);
  //   const updatedData = QuickQuotes?.map((item) => ({
  //     ...item,
  //     IsGst: checked,
  //   }));
  //   console.log(updatedData);
  //   dispatch(quick_quotes_Bike(updatedData));
  // };
  //  console.log('QuickQuotePost product',QuickQuotePost)

  return loading ? (
    <div>
      <PayHeader />
      <div className={scrolled ? `sticky` : `editquote-new`}>
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-1 col-xl-1 col-md-12 col-sm-12 edit-layout-new">
            {/* <EditOutlined
              key="save"
              style={{ cursor: "pointer" }}
              onClick={HandleBike}
            /> */}
            <Button
              type="primary"
              onClick={HandleBike}
              icon={<EditOutlined />}
              className="edit-btn-new"
            >
              Details
            </Button>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 edit-layout-new">
            {/* <div className="editbike-new">
            
            </div> */}
            <div className="editbike-new">
              <>BIKE | {fuelType} | </>
              {/* <div className="editvalueq-new">
                {bikeMakedata?.selected_rto} |
              </div> */}
              <div className="editvalueq-new">
                {bikeMakedata?.make} | {bikeMakedata?.model} |{" "}
                {bikeMakedata?.varbike}
              </div>

              {/* <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleBike}
              /> */}
            </div>
            {/* <div className="border-quote"></div> */}
          </div>
          <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 edit-layout-new">
            <div className="editbike-new">
              MANUFACTURE YEAR:{" "}
              <div className="editvalueq-new">
                {QuickQuotePost?.year_of_manufacturing}
              </div>
              {/* <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleManuf}
              /> */}
              {/* </div>
            <div className="editbike-new"> */}
            </div>
          </div>
          <div className="col-xl-1 col-lg-1 col-md-12 col-sm-12 edit-layout-new">
            <div className="editbike-new">
              RTO:{" "}
              <div className="editvalueq-new">{QuickQuotePost?.rto_code}</div>
              {/* <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={ownerType}
              /> */}
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 edit-layout-new">
            <div className="editbike-new">
              CUSTOMER TYPE:{" "}
              <div className="editvalueq-new">
                {QuickQuotePost?.partnertype}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={ownerType}
              />
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12"></div>
          {/* <div className="col-xl-2">
            <span className="gst-sec">
              GST
              {Gstload === false ? (
                <>
                  <Switch
                    defaultChecked
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    onChange={onGstChange}
                  />
                </>
              ) : (
                <Switch
                  loading
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  onChange={onGstChange}
                />
              )}
            </span>
          </div> */}
          {/* <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 edit-layout-new">
            <div className="editbike-new">
              PREVIOUS POLICY EXPIRY:{" "}
              <div className="editvalueq-new">
                {QuickQuotePost?.previousPolicyExpiryDate}
              </div>
              <EditOutlined
                key="save"
                style={{ cursor: "pointer" }}
                onClick={HandleExp}
              />
            </div>
          </div> */}
          {/* <div className="col-xl-2 col-lg-6 col-md-12 col-sm-12 edit-layout-new">
            <div className="editbike-new">
              Previous NCB :{" "}
              <div className="editvalueq-new">
                {QuoteInput?.ncbvalue === "ZERO"
                  ? "0%"
                  : QuoteInput?.ncbvalue === "TWENTY"
                  ? "20%"
                  : QuoteInput?.ncbvalue === "TWENTY_FIVE"
                  ? "25%"
                  : QuoteInput?.ncbvalue === "THIRTY_FIVE"
                  ? "35%"
                  : QuoteInput?.ncbvalue === "FORTY_FIVE"
                  ? "45%"
                  : QuoteInput?.ncbvalue === "FIFTY"
                  ? "50%"
                  : QuoteInput?.productCode === "TWT"
                  ? "N/A"
                  : ""}
              </div>
            </div>
            <div className="editbike-new">
              Current Applicable NCB :{" "}
              <div className="editvalueq-new">
                {QuoteInput?.ncbvalue === "ZERO"
                  ? "20%"
                  : QuoteInput?.ncbvalue === "TWENTY"
                  ? "25%"
                  : QuoteInput?.ncbvalue === "TWENTY_FIVE"
                  ? "30%"
                  : QuoteInput?.ncbvalue === "THIRTY_FIVE"
                  ? "45%"
                  : QuoteInput?.ncbvalue === "FORTY_FIVE"
                  ? "50%"
                  : QuoteInput?.ncbvalue === "FIFTY"
                  ? "50%"
                  : QuoteInput?.productCode === "TWT"
                  ? "0%"
                  : ""}
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <NewPlanBike setGstloading={setGstload} />

      <p className="exclusive mb-3" variant="h9">
        *Validity of the Quotation is till the end of the day on which the quote
        is generated
      </p>

      <Modal
        title="Choose the Customer Type"
        open={isModalOwner}
        footer={null}
        onCancel={handleCancelOwn}
        maskClosable={false}
      >
        <CustomerType setisModalOwner={setisModalOwner} />
      </Modal>
      <Modal
        title="Manufacture Year"
        open={isModalReg}
        footer={null}
        onCancel={handleCancelReg}
        maskClosable={false}
      >
        <ManYearupdate setisModalReg={setisModalReg} />
      </Modal>
      <Modal
        title="Vehicle Details"
        open={isModalBike}
        footer={null}
        onCancel={handleCancelBike}
        maskClosable={false}
      >
        <NewBikeedit setisModalBike={setisModalBike} />
      </Modal>
    </div>
  ) : (
    <div></div>
  );
}

export { NewPlanLayoutBike };
